import * as C from "@radix-ui/react-collapsible"
import { cn, tv } from "@utils/tw"
import { ReactNode, useId } from "react"
import { IconChevronDown } from "./Icon"

type CollapsibleProps = {
  defaultOpen?: boolean
  open?: boolean
  onOpenChange?: (open: boolean) => void
  disabled?: boolean
  trigger: ReactNode
  triggerClassName?: string
  content: ReactNode
  className?: string
  iconClassName?: string
  icon?: ReactNode
}

export function Collapsible(props: CollapsibleProps) {
  const id = useId()
  const styles = collapsibleStyles({})
  return (
    <div className={cn(styles.wrapper(), props.className)}>
      <C.Root className={styles.box()} disabled={props.disabled} onOpenChange={props.onOpenChange} id={id}>
        <C.Trigger className={cn(styles.trigger(), props.triggerClassName)}>
          {props.trigger}
          <div className={cn(styles.triggerCaret(), props.iconClassName)}>{props.icon || <IconChevronDown />}</div>
        </C.Trigger>
        <C.Content className={cn(styles.content(), "CollapsibleContent")}>{props.content}</C.Content>
      </C.Root>
    </div>
  )
}

export const collapsibleStyles = tv({
  slots: {
    wrapper: "grid gap-x-3 gap-y-2 grid-cols-1 w-full",
    box: "w-full group/box",
    trigger: "col-span-1 col-start-2 row-start-1 flex items-center justify-between type-ui-input py-2 w-full",
    triggerCaret: "group-data-[state=open]/box:-rotate-180 transform",
    content: "flex flex-col gap-2",
  },
})
